<template>
    <div>
        <template v-if="action=='view'">
            <div class="table-settings mb-4" v-if="allData.length>0 || q!=''">
                <div class="row align-items-center justify-content-between">
                    <div class="col col-md-6 col-lg-3 col-xl-4">
                        <!-- <div :class="items.id == selected_category.id ? 'btn btn-success btn-xs mx-1' : 'btn btn-secondary btn-xs mx-1' " v-for="(items, index) in categoryList" :key="index">{{ items.category_name }}</div> -->
                    </div>
                    <div class="col-4 col-md-2 col-xl-1 pl-md-0 text-right">
                                        <router-link class="btn btn-success" :to="{name : 'index', params: { page: 'subcategory', action: 'add', id: id,  code: code }}"><span class="fa fa-edit mr-2"></span>Add Subcategory</router-link>
    
                    </div>
                </div>
            </div>
            <div class="card border-light shadow-sm mb-4">
                <div class="col col-md-6 col-lg-3 col-xl-4 d-inline-flex flex-row overflow-scroll p-3 cursor-pointer">
                    <span @click.prevent="selectCategory(items)" :class="items.id == selected_category.id ? 'btn btn-success btn-xs mx-1' : 'btn btn-secondary btn-xs mx-1' " v-for="(items, index) in categoryList" :key="index">{{ items.category_name }}</span>
                </div>
                <div class="card-body" v-if="(allData.length>0)">
                    <table class="table table-hover">
                        <thead class="thead-light">
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <!-- <th>Image</th> -->
                                <th>Price</th>
                                <th>Design Price</th>
                                <th>Source File Price</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody v-if="allData.length>0">
                            <tr v-for="(data,key) in allData" :key="key">
                                <td>
                                    <a href="#" class="font-weight-bold">
                                        {{key+1}}
                                    </a>
                                </td>
                                <td><span class="font-weight-normal">{{data.sub_category_name}}</span></td>
                                <!-- <td><span class="font-weight-normal">
                                        <img v-if="data.image!=''" :src="$root.URL_ROOT+'uploads/Category/'+data.photo" width="50">
                                    </span></td> -->
                                    <td>{{ data.price }}</td>
                                    <td>{{ data.des_price }}</td>
                                    <td>{{ data.sprice ? data.sprice : 0 }}</td>
                                <td><span class="font-weight-bold">
                                        <a class="btn btn-danger btn-xs" href="#" @click="updateStatus(data, 1)" v-if="data.status==0"> Inactive</a>
                                        <a class="btn btn-success btn-xs" href="#" @click="updateStatus(data, 0)" v-if="data.status==1"> Active</a>
                                    </span></td>
                                <td>
                                    <div class="btn-group">
                                        <!-- <router-link class="btn btn-success btn-xs" :to="{name : 'index', params: { page: 'supersubcategory', action: 'view', id: data.id,  code: data.id }}"><span class="fa fa-edit mr-2"></span>Add Super Subcategory</router-link> -->
                                        <router-link class="btn btn-primary btn-xs" :to="{name : 'index', params: { page: page, action: 'edit', id: data.id , code: code  }}"><span class="fa fa-edit mr-2"></span>Edit</router-link>
                                        <!-- <a @click="remove(data.id)" class="btn btn-danger btn-xs" href="#"><span class="fa fa-trash-alt mr-2"></span>Remove</a> -->
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td class="text-center" colspan="5">No record found</td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- <div class="card-footer px-3 border-0 d-flex align-items-center justify-content-between">
                        <nav aria-label="Page navigation example">
                            <ul class="pagination mb-0">
                                <template v-for="(paginate,key) in allData.links">
                                    <li :key="key" class="page-item" :class="{'active': paginate.active}" v-if="paginate.url">
                                        <a class="page-link" @click="viewAllUrl=paginate.url;allDatas(false)" v-html="paginate.label"></a>
                                    </li>
                                </template>
                            </ul>
                        </nav>
                        <div class="font-weight-bold small">Page <b>{{allData.current_page}}</b> of <b>{{allData.last_page}}</b> page Total record <b>{{allData.total}}</b></div>
                    </div> -->
                </div>
                <div class="card-body text-center" v-else>
                    <div v-if="loading">
                        loading...
                    </div>
                    <div v-else>
                        <!-- <InlineSvg name="nouser"></InlineSvg> -->
                        <div>
                            <h3>Add and manage your {{page}}</h3>
                            <p>This is where you’ll add {{page}} and manage theme. You can also improve your website by adding.</p>
                            <router-link :to="{name : 'index', params: { page: page, action: 'add', id:0, code: code }}" class="btn btn-primary" type="button">Add {{page}}</router-link>
                            <br><br><br>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-else-if="action=='add' || action=='edit'">
            <div class="row">
                <div class="col-12 col-xl-8">
                    <div class="card card-body bg-white border-light shadow-sm mb-4">
                        <h2 class="h5 mb-4">General information</h2>
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <MssInput disabled v-model="selected_category.category_name" placeholder="Category" required></MssInput>
                            </div>
                            <div class="col-md-6 mb-3">
                                <MssInput v-model="form.sub_cat_name" placeholder="Sub-Category Name" required></MssInput>
                            </div>
                            <div class="col-md-12 mb-3">
                                <label>Sub-Category Images <span>  <i v-if="false">(Upload Image max width 1806 x height 1806 Pixels and image size max 1MB) </i> </span> </label>
                                <input type="file" name="file" ref="images" @change="handleFileChange" accept=".png, .jpg, .jpeg" multiple class="form-control my-3">
                                <span class="text-danger">
                                    * Image resolution has to be 640px X 360px, Supported file extensions: ".png, .jpg, .jpeg"
                                </span>
                                <!-- <img  v-if="action=='edit'" :src="$root.URL_ROOT+'uploads/Category/'+form.photo" style="margin-top:20px;" width="100"> -->
                                <div class="d-flex flex-row" style="overflow: hidden; overflow-x: auto;">
                                    <!-- <pre>{{ form.images }}</pre> -->
                                    <div class="card" style="width: max-content;" v-for="(image, index) in form.images">
                                        <i @click.prevent = "deleteImageForProduct(image.id)" style="position: absolute; right: 0; top: 0; color: red; cursor: pointer;" class="fa fa-times"></i>
                                        <img height="100" :src="image.image_url" :alt="form.sub_cat_name">
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 mb-3">
                                <MssInput v-model="form.price" placeholder="Price"></MssInput>
                            </div>
                            <div class="col-md-12 mb-3">
                                <MssInput v-model="form.sprice" placeholder="Source File Price"></MssInput>
                            </div>
                            <div class="col-md-12 mb-3">
                                <MssInput v-model="form.des_price" placeholder="Design Price"></MssInput>
                            </div> <!--
                            <div class="col-md-6 mb-3 text-center" v-if="action=='edit'">
                                <img v-if="form.photo!=''" :src="$root.URL_ROOT+'uploads/Category/'+form.photo" style="float:right;margin:10px" width="100">
                            </div> -->
                        </div>
                         <div class="row align-items-center">
                            <div class="col-md-12 mb-3">
                                <!-- <div class="pull-right">
                                    <MssInput type="switch" v-model="isEditor" :placeholder="isEditor ? 'Source Code' : 'View Editor'"></MssInput>
                                </div> -->
                                <label for="birthday">Sub-Category Description <span class="red-color">*</span></label>
                                <!-- <vue-editor v-if="isEditor" v-model="form.pbody" :editorToolbar="fullToolbar"></vue-editor> -->
                                <span class="text-danger" v-if="form.sub_cat_desc.length > 500">Description cannot be more than 500 characters.</span>
                                <MssInput type="textarea" v-model="form.sub_cat_desc"></MssInput>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xl-4 sidebar-stricky">
                    <div class="card card-body bg-white border-light shadow-sm mb-4">
                        <h2 class="h5 mb-4">Other Options</h2>
                        <div class="row">
                            <div class="col-md-12 mb-3">
                                <MssInput type="switch" v-model="form.status" placeholder="Visible"></MssInput>
                            </div>
                            <div class="col-md-12 mb-3">
                                <MssInput type="switch" v-model="form.print" placeholder="Print"></MssInput>
                            </div>
                            <div class="col-md-12 mb-3">
                                <MssInput type="switch" v-model="form.design" placeholder="Design"></MssInput>
                            </div>
                            <div class="col-md-12 mb-3">
                                <MssInput type="switch" v-model="form.design_n_print" placeholder="Design & Print"></MssInput>
                            </div>
                            <!-- <div class="col-md-12 mb-3">
                                <MssInput type="switch" v-model="form.is_featured" placeholder="Is Feature"></MssInput>
                            </div> -->
                            <div class="col-md-12 mb-3">
                                <div>
                                    <button @click="submit" :disabled="form.sub_cat_desc.length > 500" class="btn btn-info btn-block" v-if="action=='add'">Publish</button>
                                    <button @click="submit" :disabled="form.sub_cat_desc.length > 500" class="btn btn-success btn-block" v-else>Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
    </template>
    
    <script>
    import { VueEditor } from "vue2-editor";
    // import $ from 'jquery'
    import axios from 'axios'
    export default {
        components: {
            VueEditor
        },
        props: [
            "page", "action", "id", "code" , "type"
        ],
        data() {
            return {
                isEditor: true,
                q: '',
                loading: false,
                allData: [],
                allFiles: null,
                form: {
                    id: null,
                    lorder: 0,
                    status: true,
                    heading: '',
                    photo: '',
                    is_parent: 0,
                    is_featured: true,
                    type: 'subcategory_save',
                },
                selected_category: null,
                categoryList: [],
                editSEO: false,
                defaultSEO: true,
                pageList: [],
                fullToolbar: [
                    [{
                        'font': []
                    }],
                    [{
                        'header': [false, 1, 2, 3, 4, 5, 6, ]
                    }],
                    [{
                        'size': ['small', false, 'large', 'huge']
                    }],
                    ['bold', 'italic', 'underline', 'strike'],
                    [{
                        'align': [false, 'justify', 'center', 'right']
                    }],
                    //[{ 'header': 1 }, { 'header': 2 }],
                    //['blockquote', 'code-block'],
                    [{
                        'list': 'ordered'
                    }, {
                        'list': 'bullet'
                    }, {
                        'list': 'check'
                    }],
                    //[{ 'script': 'sub'}, { 'script': 'super' }],
                    [{
                        'indent': '-1'
                    }, {
                        'indent': '+1'
                    }],
                    [{
                        'color': []
                    }, {
                        'background': []
                    }],
                    ['link', 'image', 'video', 'formula'],
                    //[{ 'direction': 'rtl' }],
                    ['clean'],
                ],
                viewAllUrl: ''
            }
        },
        methods: {
            async deleteImageForProduct(id) { 
                const data = {
                    type: "deleteImageForProduct",
                    image_id: id
                }
                const response = await axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data
                })
                this.$toasted.global[response.data.status]({
                    message: response.data.msg
                })
                if (response.data.status = 'success') {
                    this.form.images = this.form.images.filter(e => e.id != id)
                }
            },
            selectCategory(items) {
                this.$router.push({name : 'index', params: { page: 'subcategory', action: 'view', id: items.id,  code: items.id }})
            },
            updateStatus(data, status) {
                var ev = this
                const update_data = {
                    sub_cat_id: data.id,
                    sub_cat_name: data.sub_cat_name,
                    sub_cat_desc: data.sub_cat_desc,
                    sub_cat_price: data.price,
                    sub_cat_status: status,
                    cat_id: this.selected_category.id,
                    type: 'updateSubCategory'
                }
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data: update_data
                }).then(function (response) {
                    ev.$toasted.global[response.data.status]({
                        message: response.data.msg
                    })
                    ev.allDatas()
                })
            },
    
            addInit() {
                // this.getUnderof();
                this.reset()
                this.findCategory()
            },
            editInit() {
                this.getDetail();
                // this.getUnderof();
            },
            viewInit() {
                this.findCategory()
                this.allDatas(true)
            },
            reset() {
                this.form = {
                    id: null,
                    type: 'subcategory_save',
                    lorder: 0,
                    status: true,
                    heading: '',
                    file: '',
                    is_parent: 0,
                    is_featured: true
                };
            },
            // getUnderof() {
            //     var pList = [];
            //     pList.push({
            //         label: 'Parent',
            //         code: 0
            //     })
            //     axios({
            //         method: 'POST',
            //         url: this.$root.URL_ROOT + 'api.php?type=getCategory',
            //     }).then(function (response) {
            //         var data = response.data;
            //         $.each(data, function (key, param) {
            //             pList.push({
            //                 label: param.heading,
            //                 code: param.id
            //             })
            //         })
            //     })
    
            // },
            upload_file() {
                // var ev = this;
                this.file = this.$refs.file.files[0];
    
                // let formData = new FormData();
                // console.log(formData);
                // this.save_userimage();
    
            },
            // save_userimage: function () {
            //     var ev = this;
            //     this.file = this.$refs.file.files[0];
    
            //     let formData = new FormData();
    
            //     formData.append('photo', this.file);
            //     formData.append('id', this.id);
    
            //     if (this.file == undefined) {
            //         ev.$swal({
            //             message: "please upload image"
            //         });
            //     } else {
            //      if(this.action=='edit'){
            //         axios.post(this.$root.URL_ROOT + 'api.php?type=category_edit', formData, {
            //                 headers: {
            //                     'Content-Type': 'multipart/form-data'
            //                 }
            //             })
            //             .then(function (response) {
            //                 var data = response.data;
            //                 //console.log(data);
            //                 if (data.status == "success") {
            //                     ev.$swal({
            //                         title: data.msg,
            //                     });
            //                     // ev.getUserDetail();
    
            //                 } else {
            //                     ev.$swal({
            //                         title: data.msg,
            //         // text:data.msg
            //                     });
            //                 }
            //             })
            //     }
            //     }
    
            // },
            findAllCategories() {
                var ev = this
                var param = {
                    type: 'fetchAllCategories'
                }
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data: param
                }).then(function (response) {
                    ev.categoryList = response.data.data
                })
            },
            findSubCategory(id) {
                var ev = this
                var param = {
                    sub_cat_id: id,
                    type: 'fetchSubCategory'
                }
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data: param
                }).then(function (response) {
                    ev.form = {
                        id: response.data.data[0].id,
                        sub_cat_name: response.data.data[0].sub_category_name,
                        sub_cat_desc: response.data.data[0].sub_category_description,
                        price: response.data.data[0].price,
                        des_price: response.data.data[0].des_price,
                        status: response.data.data[0].status,
                        cat_id: response.data.data[0].cat_id,
                        print: response.data.data[0].print,
                        design: response.data.data[0].design,
                        design_n_print: response.data.data[0].design_n_print,
                        images: response.data.data[0].images,
                    }
                })
            },
            findCategory() {
                var ev = this
                var param = {
                    cat_id: this.code ? this.code : this.selected_category.id ,
                    type: 'fetchAllCategories'
                }
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data: param
                }).then(function (response) {
                    ev.selected_category = response.data.data[0]
                })
            },
            getDetail() {
                this.findCategory()
                this.findSubCategory(this.id)
                // var ev = this
                // var param = {
                //     id: this.id,
                //     type: 'getSingleCategory'
                // }
                // axios({
                //     method: 'POST',
                //     url: this.$root.URL_ROOT + 'api.php',
                //     data: param
                // }).then(function (response) {
                //     var data = response.data;
                //     ev.form = data.category
                // })
            },
            allDatas() {
                var ev = this
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data: {
                        type: 'fetchSubCategory',
                        cat_id: this.code ? this.code : this.selected_category.id ,
                    }
                }).then(function (response) {
                    var data = response.data;
                    ev.allData = data.data
                })
            },
            handleFileChange(event) {
                const ev = this
                this.allFiles = new FormData()
                let item = 1
                event.target.files.forEach(e => {
                    let img = new Image()
                    img.src = window.URL.createObjectURL(e)
                    img.addEventListener('load', function () {
                        if (img.width != 640 && img.height != 360) {
                            ev.$toasted.global.error({
                                message: `${e.name} is not matching 640px X 360px.`
                            })
                        } else {
                            ev.allFiles.append(`file${item}`, e)
                            item += 1
                        }
                    })
                })
            },
            submit() {
                var ev = this
                // this.file = this.$refs.file.files[0];
                if (this.form.sub_cat_name === '') {
                    this.$toasted.global.error({
                        message: 'Please enter sub-category name '
                    })
                } 
                // else if (this.file === '') {
                //     this.$toasted.global.error({
                //         message: 'Please Select Image'
                //     })
                // } 
                else {
                var status = ''
                    if(ev.form.status==true){
                        status = 1
                    }else{
                        status = 0
                    }
                if (!this.form.sub_cat_name || this.form.sub_cat_name === '') {
                    ev.$toasted.global.error({
                        message: 'Please enter a sub category name.'
                    })
                    return 
                }
                if (!this.form.price || this.form.price === '') {
                    ev.$toasted.global.error({
                        message: 'Please enter a sub category price.'
                    })
                    return 
                }
                if (!this.form.des_price || this.form.des_price === '') {
                    ev.$toasted.global.error({
                        message: 'Please enter a sub category design price.'
                    })
                    return 
                }
                const data = this.action == 'add' ? {
                    sub_cat_name: this.form.sub_cat_name,
                    sub_cat_desc: this.form.sub_cat_desc,
                    sub_cat_price: this.form.price,
                    sub_cat_sprice: this.form.sprice,
                    sub_cat_status: status,
                    sub_cat_des_price: this.form.des_price,
                    sub_cat_print: this.form.print ? this.form.print : false,
                    sub_cat_design: this.form.design ? this.form.design : false,
                    sub_cat_design_n_print: this.form.design_n_print ? this.form.design_n_print : false,
                    cat_id: this.selected_category.id,
                    type: 'createSubCategory'
                } : {
                    sub_cat_id: this.form.id,
                    sub_cat_name: this.form.sub_cat_name,
                    sub_cat_desc: this.form.sub_cat_desc,
                    sub_cat_price: this.form.price,
                    sub_cat_sprice: this.form.sprice,
                    sub_cat_des_price: this.form.des_price,
                    sub_cat_print: this.form.print ? this.form.print : false,
                    sub_cat_design: this.form.design ? this.form.design : false,
                    sub_cat_design_n_print: this.form.design_n_print ? this.form.design_n_print : false,
                    sub_cat_status: status,
                    cat_id: this.selected_category.id,
                    type: 'updateSubCategory'
                }
                    // let formData = new FormData();
                    // if (this.action == 'edit') {
                    //     formData.append('id', this.id);
                    //     this.form.type = 'subcategory_edit';
                    // }
                    // formData.append('sub_cat_name', this.form.lorder);
                    // // formData.append('photo', this.file);
                    // formData.append('sub_cat_desc', this.form.heading);
                    // formData.append('sub_cat_price', this.form.pbody);
                    // formData.append('sub_cat_status', status);
                    // formData.append('type', this.form.type);
                    axios({
                        method: 'POST',
                        url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                        data: data
                    }).then(function (response) {
                        var data = response.data;
                        if (data.status == "success") {
                            axios({
                                method: 'POST',
                                url: ev.$root.URL_ROOT + 'updatedApiForProducts.php?type=uploadImageForProduct',
                                data: ev.allFiles
                            }).then((response) => {
                                const image_ids = response.data.data.map(e => {
                                    return parseInt(e)
                                })
                                const sub_cat_id = parseInt(data.data)
                                axios({
                                    method: 'POST',
                                    url: ev.$root.URL_ROOT + 'updatedApiForProducts.php?type=assignProductDetails',
                                    data: ev.action == 'add' ? {
                                        image_ids, sub_cat_id
                                    } : {
                                        image_ids, sub_cat_id: ev.form.id
                                    }
                                }).then((response) => {
                                    console.log(response);
                                    ev.$swal({
                                        toast: true,
                                        position: 'top-end',
                                        timer: 5000,
                                        icon: 'success',
                                        timerProgressBar: true,
                                        title: 'Action perform successfully'
                                    })
                                    ev.$router.push({
                                        name: 'index',
                                        params: {
                                            page: ev.page,
                                            action: 'view',
                                            // id: ev.code,
                                            // code: ev.code,
                                        }
                                    })
                                })
                            })
                        } else {
                            setTimeout(() => ev.$swal(data.msg), 1000);
                        }
                    })
                }
            },
            remove(id) {
                var self = this;
                var param = {
                    id: id,
                    table: 'mss_category',
                    type: 'commonDelete'
                }
                this.$swal({
                    title: "Delete this ?",
                    text: "Are you sure? You won't be able to revert this!",
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor: "#f00",
                    confirmButtonText: "Yes, Delete it!",
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios({
                            method: 'POST',
                            url: this.$root.URL_ROOT + 'api.php',
                            data: param
                        }).then(function (response) {
                            var data = response.data;
                            console.log('commonDelete', data)
                            self.allDatas()
                        })
                    }
                })
            }
        },
        mounted() {
            this.findAllCategories()
            if (this.action == "view") {
                this.viewInit()
                this.findCategory()
            } else if (this.action == "edit" && this.id > 0) {
                this.editInit()
            } else if (this.action == "add") {
                this.addInit();
            }
        },
        watch: {
            'action': function (val) {
                if (val == "view") {
                    this.viewInit()
                } else if (val == "edit" && this.id > 0) {
                    this.editInit()
                } else if (val == "add") {
                    this.addInit();
                }
            },
            code() {
                if (this.action == "view") {
                    this.viewInit()
                } else if (this.action == "edit" && this.id > 0) {
                    this.editInit()
                } else if (this.action == "add") {
                    this.addInit();
                }
            },
            id() {
                if (this.action == "view") {
                    this.viewInit()
                } else if (this.action == "edit" && this.id > 0) {
                    this.editInit()
                } else if (this.action == "add") {
                    this.addInit();
                }
            },
            'form.linkname': function (val) {
                var text = val.replace(' ', "")
                this.form.linkname = text
            },
            'loading': function (val) {
                if (val) {
                    this.$swal.showLoading();
                } else {
                    this.$swal.close()
                }
            },
            'q': function (newVal, oldVal) {
                if (newVal == '') {
                    this.viewAllUrl = this.URL_ROOT + 'admin/' + this.page + '/all';
                } else if (newVal != oldVal) {
                    this.viewAllUrl = this.URL_ROOT + 'admin/' + this.page + '/all/' + newVal;
                }
                this.allDatas(false);
            }
        }
    }
    </script>
    
    <style scoped>
    @import "~vue2-editor/dist/vue2-editor.css";
    </style>
    